// extracted by mini-css-extract-plugin
export default {"root":"_3nt1Z","img":"hj2ku","numberContainer":"_2-dQL","number":"_3mQOY","title":"_37qek","instructions":"_33Rln","text":"_1UioN"};